<template>
  <div class="modal-background" :class="{ 'top-right': position === 'top-right' }" @click="handleBackgroundClick">
    <div class="modal-content">
      <button class="modal-close-btn" @click="close">&times;</button>
      <slot name="header" />
      <slot name="body" />
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: String,
      default: 'center', // 'center' or 'top-right'
    },
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    },
    handleBackgroundClick(event) {
      // Fermer la modale seulement si on clique sur le fond (pas sur le contenu)
      if (event.target === event.currentTarget) {
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.modal-background {
  position: fixed;
  z-index: 9;
  inset: 0;
  background-color: var(--half-transparent);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-background.top-right {
  justify-content: flex-start;
  align-items: flex-end;
  padding: 20px;
}

.modal-background.top-right .modal-content {
  pointer-events: auto;
}

.modal-content {
  position: relative;
  z-index: 10;
  background: var(--bg-secondary);
  padding: 30px;
  border-radius: 10px;
  width: 400px;
}

.modal-close-btn {
  position: absolute;
  top: 12px;
  right: 14px;
  background: none;
  border: none;
  font-size: 1.4rem;
  line-height: 1;
  color: var(--text);
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
}

@media (hover: hover) {
  .modal-close-btn:hover {
    color: var(--text);
    background-color: var(--bg-tertiary);
  }
}

@media (max-width: 769px) {
  .modal-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-y: auto;
  }
}
</style>
